/**
 * Created by joerg on 20.05.17.
 */
import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import Utils from '../utils/Utils';
import InputComponent from '../components/InputComponent';
import OutPutComponent from '../components/OutPutComponent';
import InputModel from '../models/InputModel'
import DropDown from '../components/DropDown'



@observer
export default class BaseDicken extends React.Component {

    _onChange(e,entry){
        console.log('ch',e.target.value,entry)
        entry.value = e.target.value;
    }
    componentDidUpdate(){
        setTimeout(()=>{requestAnimationFrame(this._calcwidths);},200);

    }
    componentDidMount(){
        this.componentDidUpdate();
    }
    _calcwidths(){
       // console.log('calcwidth')

        Utils.normalizeAddonWidths('#basedicken')



    }

    render (){
        const {baseDataStore,brespaDataStore} = this.props;
      //  const self = this;
        //console.log("entfcomp",baseDataStore.entfernungcomp.value)
        var z = 200;
        var showtxt = (baseDataStore.dickeforderlichob.value - brespaDataStore.plattendicke.value > 8);
        if(baseDataStore.isPossible.possible == false){
            return <div id="basedicken" className="well">
                <h4>Achtung</h4>
                <p>
                    {(baseDataStore.isPossible.reasons.indexOf("2") >= 0)?"Ein Transport von BRESPA®-Decken von Schneverdingen aus ist bis zum Bauort ökonomisch wie ökologisch nicht sinnvoll. " +
                        "Bitte ändern Sie die Postleitzahl, um das Programm fortzusetzen. Bei konkreten Projekten nehmen Sie gerne mit uns Kontakt auf.<a href='mailto:info@dw-systembau.de'>info@dw-systembau.de</a>":""}
                 </p>
                <p>
                    {(baseDataStore.isPossible.reasons.indexOf("1") >= 0)?"Das Programm ist für Geschosswohnungsbauprojekte ab einer Gesamtdeckenfläche von 500 m² konzipiert. " +
                        "Ändern Sie bitte die Geschossigkeit oder die Gebäudeabmessungen.":""}
                </p>
            </div>;
        }
        return <div id="basedicken" className="well">
            <h4>Deckenstärken</h4>
            <hr/>
            <div className='row'>
                <div className='col-md-4'>
                    <div key={brespaDataStore.brespaselection.key} className="form-group zup" style={{zIndex : z}}>
                        <div className="input-group size-input-height" style={{width:'100%'}} >
                            <div className="input-group-addon left-addon-dd" dangerouslySetInnerHTML={{__html: brespaDataStore.brespaselection.title}}></div>
                            <div className="input-group-btn ">
                                <DropDown key={brespaDataStore.brespaselection.key} dataProvider={brespaDataStore.brespaselection} onSelect={brespaDataStore.brespaselection.onSelect}/>
                            </div>
                        </div>
                    </div>
                    {baseDataStore.entries4.map(entry => {
                            z--;
                            var styles = {zIndex : z};
                            if (entry instanceof InputModel) {
                                return( <div className="form-group zup" key={entry.key} style={styles}>

                                    <InputComponent inputModel={entry} inputClasses={['size-input-height']}/>
                                </div>)
                            }else{
                                return (<div key={entry.key} className="form-group zup" style={styles}>
                                    <div className="input-group size-input-height" style={{width:'100%'}} >
                                        <div className="input-group-addon left-addon-dd" dangerouslySetInnerHTML={{__html: entry.title}}></div>
                                        <div className="input-group-btn ">
                                            <DropDown key={entry.key} dataProvider={entry} onSelect={entry.onSelect}/>
                                        </div>
                                    </div>
                                </div>)
                            }

                        }
                    ) }

                </div>
                <div className='col-md-8'>
                    <img className="img-responsive" src={`${process.env.PUBLIC_URL}/images/${baseDataStore.strukturAuswahl.selectedOption.value.img}`}/>
                </div>

            </div>

                <div className={"mt-15 row " + (showtxt?"":"hidden")}>
                    <div className="col-md-12"><p>Diese Stützweiten sind für Halbfertigteile und Ortbetondecken
                        unwirtschaftlich.<br/>
                        Ändern Sie das statische System oder wir fügen die zusätzlich erforderlichen statischen Deckenauflager zum Preis von 300 € / lfd. m hinzu, <br/>
                        so dass die Deckendicken denen der BRESPA®-Decken entsprechen und die Mehrkosten der zusätzlichen Deckenauflager auf die m²-Preise umgelegt und unter Kosten und Ergebnisse separat ausgewiesen werden.</p>
                    </div>
                </div>


        </div>;
    }

}

BaseDicken.propTypes = {
    baseDataStore: PropTypes.object.isRequired,
    brespaDataStore: PropTypes.object.isRequired
}


// WEBPACK FOOTER //
// ./src/components/BaseDicken.js